import React from 'react'
import { withStyles } from 'material-ui/styles'
import Amount from 'components/Amount'
import Typography from 'material-ui/Typography'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import compose from 'recompose/compose'
import { capitalize } from 'lodash'
import Bar from 'components/Bar'
const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 400,
    height: 80,
    [theme.breakpoints.down('md')]: {
      height: 60,
    },
    // align with total
    paddingBottom: 11,
    paddingTop: 11,
  },
  title: {
    fontSize: 17,
    display: 'flex',
    marginBottom: 10,
  },
  titleText: {
    flexGrow: 1,
    fontSize: 22,
    alignSelf: 'center',
  },
  value: {
    fontSize: 30,
  },
})

class HighlightedCurrencyLegend extends React.Component {
  render() {
    const {
      funds,
      cryptocurrencies,
      classes,
      colour,
      highlightedCurrencies,
    } = this.props
    if (highlightedCurrencies.length < 1) {
      return <div className={classes.root} />
    }
    const fund = funds.find(f => f.currency === highlightedCurrencies[0])
    return (
      <div className={classes.root}>
        <div className={classes.title}>
          <Typography type="button" className={classes.titleText}>
            {capitalize(cryptocurrencies[highlightedCurrencies[0]])}
          </Typography>
          <Amount value={fund.value} mainCurrency className={classes.value} />
        </div>
        <Bar fund={fund} big colour={colour} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  funds: selectors.fundsWithValueMergedByCrypto(state),
  highlightedCurrencies: selectors.highlightedCurrencies(state),
  cryptocurrencies: selectors.cryptocurrencies(state),
})

export default compose(withStyles(styles), connect(mapStateToProps, null))(
  HighlightedCurrencyLegend
)



// WEBPACK FOOTER //
// ./src/components/HighlightedCurrencyLegend.js